// extracted by mini-css-extract-plugin
export default {"errorPageWrapper":"ErrorPage_errorPageWrapper__yi6rt"};